<template>
  <div>
    <table class="table b-table table-sm bg-white table-borderless" v-if="user.unidade">
      <load v-if="loading" mode="table" />
      <tbody v-else>
        <tr>
          <td class="text-left logo-cell">
            <img v-if="config.app_icon" :src="'/storage/' + config.app_icon" :alt="user.unidade.nome"
              style="max-width: 80px; max-height: 80px" />
            <img v-else src="/img/app/icon.png" alt="Logotipo SUAS Fácil" style="max-width: 80px; max-height: 80px" />
          </td>
          <td>
            <p>
              Unidade: <strong>{{ user.unidade.nome }} </strong>
            </p>
            <p v-if="user.unidade.endereco">
              Endereço:
              <strong>{{ user.unidade.endereco.logradouro.tipo_logradouro }}
                {{ user.unidade.endereco.logradouro.nome_logradouro }},
                {{ user.unidade.endereco.numero_endereco }} - Bairro:
                {{
                  user.unidade.endereco.localidade
                    ? user.unidade.endereco.localidade.nome_localidade
                    : ""
                }}
                - CEP:
                {{
                  user.unidade.endereco.logradouro
                    ? user.unidade.endereco.logradouro.cep_logradouro
                    : ""
                }}
                - {{ user.unidade.endereco.cidade.nome }}/{{
                  user.unidade.endereco.estado.sigla
                }}
              </strong>
            </p>
            <p>
              E-mail: <strong>{{ user.unidade.email }} </strong> - Telefone:
              <strong>{{ user.unidade.telefone }} </strong>
            </p>
          </td>
        </tr>
        <tr v-if="titulo">
          <td class="text-center" colspan="2">
            {{ titulo }}
          </td>
        </tr>
        <tr v-if="titulo">
          <td colspan="2">
            <span class="text-small text-muted" style="font-size: 12px">Data de extração dos dados: <b>{{ dataatual
                }}</b></span>
          </td>
        </tr>
        <tr v-if="data_inicial">
          <td colspan="2">
            Data Inicial: <b>{{ data_inicial }}</b> Data Final:
            <b>{{ data_final }}</b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["titulo", "data_inicial", "data_final"],
  name: "PrintHeader",
  data() {
    return {
      user: {
        unidade: {
          avatar: null,
        },
      },
      config: { app_icon: null },
      loading: true,
    };
  },
  created() {
    this.getUser();
    this.getSettings();
  },
  methods: {
    getUser() {
      // axios
      //   .post("/api/auth/user")
      //   .then((response) => {
      //     this.user = response.data.user;
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   })
      //   .catch(() => {
      //     swal.fire({
      //       icon: "error",
      //       text: "Algo deu errado ao carregar o cabeçalho de impressão!",
      //       showConfirmButton: false,
      //     });
      //   });
      this.user = this.$store.state.user;
    },
    getSettings() {
      axios
        .get("/api/dashboard/suportes/settings/app_icon")
        .then((response) => {
          const appIcon = response.data.data;
          this.config.app_icon = appIcon.value.text;
          this.user.unidade.avatar = appIcon.value.text;
        })
        .catch(() => {
          console.error("Algo deu errado ao carregar as configurações!");
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.table {
  border: none !important;
}

.table td,
.table th {
  border: none !important;
}

.table td.logo-cell {
  width: 120px;
  text-align: center;
  padding: 10px;
  vertical-align: middle;
}
</style>
